import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import Input from '../../components/Forms/Input.jsx';
import AuthStore from '../../reflux/stores/AuthStore';
import AuthActions from '../../reflux/AuthActions';
import AlertActions from '../../reflux/AlertActions';

class Perfil extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    
    componentWillMount() {
        AlertActions.configureAppBar('Mi Perfil', null);
        AuthActions.getUser();
        this.unsubscribe = AuthStore.listen(this.handleAuth);
    }
    
    componentWillUnmount() {
        this.unsubscribe();
    }

    handleAuth(e, user) {
        if (e === 'getUser')
            this.setState({user: user});

        if (e === 'putUser')
            AlertActions.alert('open', 'Perfil editado', 'Ha editado su perfil satisfactoriamente');
    }

    handleInputChange(e, val) {
        const name = e.target.name;
        let user = this.state.user;
        switch(name) {
            case 'password':
                user[name] = val;
                break;
            case 'password_confirmation':
                user[name] = val;
                break;
            default:
                user.cliente[name] = val;
                break;
        }

        this.setState({user: user});
    }
    
    onSubmit(e) {
        e.preventDefault();
        AuthActions.putUser(this.state.user);
    }

    render() {
        let form = null;

        if (this.state.user !== null)
            form = (
                <form onSubmit={this.onSubmit} action="/user" method="post">
                    <Input
                        validations="required"
                        fullWidth={true} 
                        name="name"
                        floatingLabelText="Nombre o Razón Social"
                        val={this.state.user.cliente.name}
                        onChange={this.handleInputChange}
                        debounce={0} />

                    <Input
                        validations="required,rif"
                        fullWidth={true} 
                        name="rif"
                        floatingLabelText="Registro de Informacion Fiscal (R.I.F.)"
                        val={this.state.user.cliente.rif}
                        onChange={this.handleInputChange}
                        debounce={0} />

                    <Input
                        validations="required,email"
                        fullWidth={true} 
                        name="email"
                        floatingLabelText="Correo Electronico"
                        val={this.state.user.cliente.email}
                        onChange={this.handleInputChange}
                        debounce={0} />
                    
                    <Input
                        validations="required,alpha_dash"
                        fullWidth={true} 
                        name="phone"
                        floatingLabelText="Telefono"
                        val={this.state.user.cliente.phone}
                        onChange={this.handleInputChange}
                        debounce={0} />
                    
                    <Input
                        validations="required"
                        fullWidth={true} 
                        name="address"
                        floatingLabelText="Direccion"
                        val={this.state.user.cliente.address}
                        onChange={this.handleInputChange}
                        debounce={0} />
                    
                    <br/>
                    <br/>

                    <Input
                        validations="min:6"
                        fullWidth={true} 
                        name="password"
                        type="password"
                        floatingLabelText="Password (Dejar en blanco si no desea cambiarla)"
                        val={this.state.user.password}
                        onChange={this.handleInputChange}
                        debounce={0} />

                    <Input
                        validations="min:6"
                        fullWidth={true} 
                        name="password_confirmation"
                        type="password"
                        floatingLabelText="Confirmar Password"
                        val={this.state.user.password_confirmation}
                        onChange={this.handleInputChange}
                        debounce={0} />

                    <RaisedButton type="submit" label="Guardar" primary={true}/>
                </form>
            );

        return (
            <div style={{maxWidth:500, margin:'auto'}}>
                <Paper style={{padding:'5px 20px 20px 20px', marginTop:35}}>
                <h2 className="center">Datos del Usuario</h2>
                    {form}
                </Paper>
            </div>
        );
    }
}

export default Perfil;


/** WEBPACK FOOTER **
 ** ./app-react/pages/User/Perfil.jsx
 **/